namespace appn.views.repositoryAdmin.clientInstall {

    export function init(): void {
        const $appnForm = $('#appnForm');
        appn.iframe.bindSubmitButtonsAndNavLinks($appnForm);

        // Dynamically set the selected Forms/Docs into Model.SelectedItems
        const selectedItems = (parent as any).appn.views.repositoryAdmin.index.selectedItems;
        selectedItems.each(function(index: number, item: JQuery<HTMLElement>) {
            $('#appnForm').append('<input type="hidden" name="SelectedItems[' + index + ']" value="' + $(item).prop('id') + '" />');
        });

        addEvents();
    }

    function addEvents(): void {
        // Bind Install Modal View Switch
        $('.switch-install-method').on('click', function(event) {
            event.preventDefault();

            if (event && event.target.classList.contains('linked'))
                unlinkedInstall();

            if (event && event.target.classList.contains('unlinked'))
                linkedInstall();
        });

        $('.chk-keep-in-sync').on('change', function(event) {
            const currentValue = $(this).is(':checked');
            $('#appnForm input[name="KeepInSync"]').remove();
            $('#appnForm').append(`<input type="hidden" name="KeepInSync" value="${currentValue}" />`);
        });
    }

    function linkedInstall() {
        // Reset the hidden property and clear the fields when returning to normal install
        $('#IsIntegrationInstall').removeAttr('checked');
        $('#IsIntegrationInstall').attr('value', 'false');
        $('#CompanyId').val(appn.emptyString);
        $('#IntegrationKey').val(appn.emptyString);

        const thisBoxTypeList = $('div.unlinked');

        thisBoxTypeList.each(function(index, currentBox) {
            const boxParent = currentBox.parentElement as HTMLElement;
            boxParent.classList.add('d-none');
        });

        const otherBoxTypeList = $('div.linked');
        otherBoxTypeList.each(function(index, currentBox) {
            const boxParent = currentBox.parentElement as HTMLElement;
            boxParent.classList.remove('d-none');
        });
    }

    function unlinkedInstall() {
        $('#IsIntegrationInstall').attr('checked', 'true');

        const thisBoxTypeList = $('div.linked');

        thisBoxTypeList.each(function(index, currentBox) {
            const boxParent = currentBox.parentElement as HTMLElement;
            boxParent.classList.add('d-none');
        });

        const otherBoxTypeList = $('div.unlinked');
        otherBoxTypeList.each(function(index, currentBox) {
            const boxParent = currentBox.parentElement as HTMLElement;
            boxParent.classList.remove('d-none');
        });
    }
}
